import React from 'react';
import { FaLaptopCode, FaClock, FaShieldAlt, FaCloud, FaRocket, FaUsers, FaLightbulb, FaCode } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/StorySection.css';
import image from '../assets/images/what-we-do.jpg'

const StorySection = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <FaLaptopCode />,
      title: 'Custom Software Development',
      description: 'Tailored solutions built with modern technologies'
    },
    {
      icon: <FaCloud />,
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and deployment'
    },
    {
      icon: <FaShieldAlt />,
      title: 'IT Security',
      description: 'Robust security measures for your digital assets'
    },
    {
      icon: <FaClock />,
      title: '24/7 Support',
      description: 'Round-the-clock technical support and maintenance'
    },
    {
      icon: <FaRocket />,
      title: 'Fast Delivery',
      description: 'Rapid development and timely project delivery'
    },
    {
      icon: <FaUsers />,
      title: 'Team Collaboration',
      description: 'Dedicated teams working as your partners'
    },
    {
      icon: <FaLightbulb />,
      title: 'Innovation',
      description: 'Cutting-edge solutions for modern challenges'
    },
    {
      icon: <FaCode />,
      title: 'Quality Code',
      description: 'Clean, maintainable, and scalable codebase'
    }
  ];

  return (
    <section className="story-section">
      <div className="container">
        {/* Main Content */}
        <div className="story-content" data-aos="fade-up">
          <div className="story-grid">
            {/* Image Section */}
            <div className="story-image" data-aos="fade-right" data-aos-delay="200">
              <div className="image-container">
                <img
                  src={image}
                  alt="TechSol Technologies Team"
                  className="story-img"
                />
                <div className="image-overlay"></div>
                <div className="image-badge">
                  <span>Since 2024</span>
                </div>
              </div>
            </div>

            {/* Content Section */}
            <div className="story-text" data-aos="fade-left" data-aos-delay="300">
              <div className="section-header">
                <h2 className="section-title">
                  What We Do
                </h2>
                <div className="title-underline"></div>
              </div>
              
              <p className="story-description">
                We specialize in creating custom software solutions that empower your business. 
                From responsive websites and mobile apps to AI-powered systems and innovative designs, 
                we turn your challenges into opportunities. Let's work together to bring your digital vision to life!
              </p>

              <div className="story-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">🚀</div>
                  <div className="highlight-content">
                    <h4>Digital Transformation</h4>
                    <p>Modernize your business with cutting-edge technology</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">💡</div>
                  <div className="highlight-content">
                    <h4>Innovation Driven</h4>
                    <p>Creative solutions for complex business problems</p>
                  </div>
                </div>
              </div>

              <button 
                className="cta-button" 
                onClick={() => navigate('/services')}
              >
                <span>Explore Our Services</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="features-section" data-aos="fade-up" data-aos-delay="400">
          <div className="section-header text-center">
            <h3 className="features-title">Our Expertise</h3>
            <p className="features-subtitle">
              Comprehensive digital solutions tailored to your business needs
            </p>
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="feature-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="feature-icon-wrapper">
                  <div className="feature-icon text-white">
                    {feature.icon}
                  </div>
                </div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;